export enum TipoCanalesNombre {
  WEB = 'Web',
  APP = 'App',
  OFV = 'Oficina Virtual',
}
